<template>
  <div v-if="show">
    <section class="extlinkcardswd" resmed-component-name="extlinkcardswd">
      <div class="component">
        <div
          class="col-12 text-center headline-text"
          v-bind:class="`-mode-${[$root.mode]}`"
        >
          <div class="row">
            <div
              class="
                col-lg-4 col-xs-6 col-sm-4
                mb-3
                d-flex
                align-items-stretch
                extlinkcardswd-custom
              "
              v-for="(item, index) in acf.items"
              :key="index"
              style="padding: 0px 6px"
            >
              <div class="elcwd">
                <div class="card">
                  <a
                    v-bind:href="isUser ? item.cta_internal : item.cta"
                    target="_blank"
                  >
                    <img
                      v-bind:src="item['image-desktop']"
                      class="card-img-top extlinkcardswd-image"
                      alt="Card Image"
                      style="width: 100%"
                    />
                  </a>
                  <div
                    class="
                      card-body
                      d-flex
                      flex-column
                      p-3
                      extlinkcardswd-card-body
                    "
                  >
                    <div class="card-title-container">
                      <h5
                        class="card-title"
                        style="font-size: 14px; font-weight: 800;margin-bottom: 10px;"
                      >
                        {{ item.title }}
                      </h5>
                      <div
                        class="card-text mb-2"
                        style="font-size: 14px"
                        v-if="$root.mode === 'lg' || $root.mode === 'xl' || $root.mode === 'md'"
                      v-html="isUser ? item.description_internal: item.description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- //container end -->
        </div>
      </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "extlinkcardswd", // extlinkcardswd
  props: ["acf"],
  data() {
    return {
      items: this.acf.items,
      isUser: false,
    };
  },
  methods: {
    isResmedUser() {
      const email = this.$cookies.get("rocEmail");
      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.isUser = this.isResmedUser();
    // find the heighest card title container height and assign it as height
    let maxHeight = 0;

    $("div.card-title-container .card-title").each(function() {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });

    $("div.card-title-container .card-title").height(maxHeight);
  },

  computed: {
    show() {
      const role = this.$cookies.get("role");
      const b2bFirstName = this.$cookies.get("b2bFirstName");

      const roles = (role && role.split(",").map((r) => r.trim())) || [];
      const hasAnyTechnicalRole = roles.some(
        (r) =>
          r.includes("sleep_approved") ||
          r.includes("ventilator_approved") ||
          r.includes("oxygen_approved")
      );

      if (hasAnyTechnicalRole && b2bFirstName) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.extlinkcardswd-card-body {
  background: #f2f2f2;
  border-radius: 0 0 4px 4px;
  @media screen and (max-width: 767px) {
    background: #ffffff;
    padding: 1rem 0 0 !important;
  }

  .card-title {
    margin-bottom: 0;
  }
}

.extlinkcardswd {
  // padding: 0 4rem;
  @media (width: 768px) {
    padding: 0;
  }
  @media (max-width: 767px) {
    padding: 0 1rem;
  }
}

h2 {
  position: relative;
  margin-bottom: 0.5rem;

  @extend %eyebrow-center;
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;

  @extend %eyebrow-left;
}

p {
  margin: 0 auto 1.5rem auto;
}
.elcardstrow {
  padding: 1em;
  @media (max-width: 768px) {
    padding: 1em;
    background-size: cover;
    width: 50%;
  }
}
.elcards {
  padding: 2em 0em;
  border: 1px solid;
  border-radius: 10px;
  padding-top: 6em;

  @media (max-width: 768px) {
    padding: 2em 0em;
    padding-top: 2em;
    background-size: cover;
    height: 150px;
  }
}
.elincard {
  padding: 0px 10px;
  height: 300px;
  @media (max-width: 768px) {
    padding: 0px 10px;
    height: 150px;
  }
}
.elcardsh5 {
  padding: 15px;
  background: #2121217a;
  color: #ffffff;
}

.elcwd,
.elcwd:hover {
  // cursor: pointer;
  color: #0c0c0c;
}

.extlinkcardswd-custom {
  width: 100%;
  @media (max-width: 767px) {
    width: 50%;
  }
}

.extlinkcardswd-image {
  border-radius: 4px 4px 0 0;

  @media (max-width: 767px) {
    border-radius: 10px;
  }
}

h5.card-title {
  @media (max-width: 767px) {
    font-size: 13px !important;
  }
}
.elcwd {
  background: #f2f2f2;
  border-radius: 6px;
  @media (max-width: 767px) {
    background: #ffffff;
  }
}

.card-title-container {
  height: 100%;
}
</style>
